/**
 * DO NOT EDIT THIS FILE
 */

import store from "@/store";
import router from "@/router";

import ParticipantsView from "@/admin/views/ParticipantsView.vue";
import SettingsView from "@/admin/views/SettingsView.vue";
import ContentView from "@/admin/views/ContentView.vue";
import MetricsView from "@/admin/views/MetricsView.vue";
import ConfigView from "@/admin/views/ConfigView.vue";
import InstructionsView from "@/admin/views/InstructionsView.vue";

import { nameMapping } from "@/admin/";

// Routes
//
const routeParticipants = {
  path: "/admin/participants",
  name: "Participants",
  component: ParticipantsView
};

const routeSettings = {
  path: "/admin/settings",
  name: "Settings",
  component: SettingsView
};
const routeContent = {
  path: "/admin/content",
  name: "Content",
  component: ContentView
};

const routeMetrics = {
  path: "/admin/metrics",
  name: "Metrics",
  component: MetricsView
};

const routeConfig = {
  path: "/admin/config",
  name: "Config",
  component: ConfigView
};
const routeInstructions = {
  path: "/admin/instructions",
  name: "Instructions",
  component: InstructionsView
};

/**
 * Routes
 * */
const adminRoutes = [];

if (import.meta.env.VITE_USE_DATASTORE) {
  adminRoutes.push(routeParticipants);
}

if (import.meta.env.VITE_CONTENT_API_KEY) {
  adminRoutes.push(routeContent);
}
if (import.meta.env.VITE_METRICS_API_KEY) {
  adminRoutes.push(routeMetrics);
}

if (import.meta.env.VITE_SHOW_ADMIN_INSTRUCTIONS) {
  adminRoutes.push(routeInstructions);
}

if (import.meta.env.VITE_SHOW_ADMIN_CONFIG) {
  adminRoutes.push(routeConfig);
}

if (import.meta.env.VITE_SETTINGS_API_KEY) {
  adminRoutes.push(routeSettings);
}

/**
 *
 */
adminRoutes.forEach((route) => {
  route.meta = route.meta || {};
  route.meta.label = nameMapping[route.name] ?? route.name;
  route.beforeEnter = [authUser, authAdmin];
});

function authAdmin(_to, _from, next) {
  if (!store.getters.isAdmin) {
    console.warn("NOT ADMIN");
    return;
  }
  next();
}

function authUser(to, _from, next) {
  if (!store.getters.useAuth) {
    console.warn("No Auth");
    return;
  }

  if (!store.getters.publicKey) {
    console.warn("No Public Key");
    return;
  }

  if (to.query) {
    if (to.query.jwt) {
      store.dispatch("setToken", to.query.jwt);
      delete to.query.jwt;
      router.replace(to);
    }
  }

  if (store.getters.getToken) {
    if (store.getters.isAuthenticated) {
      next();
    } else {
      requestToken();
    }
  } else {
    requestToken();
  }
}

function requestToken() {
  let originalQuery =
    window.location.href.split("?").length > 1
      ? window.location.href.split("?")[1]
      : "";

  // Redirect the user back to the current page
  const redirect = window.location.href.split("?")[0];

  // Create the params needed by the auth endpoint
  const params = {
    public_key: store.getters.publicKey,
    query: originalQuery,
    redirect: redirect
  };

  const query = new URLSearchParams(Object.entries(params));
  query.toString();

  // Redirect the user to the auth endpoint

  window.location.href =
    `https://courses.ecampus.oregonstate.edu/services/auth/public/v1/token` +
    "?" +
    query;
}

export { adminRoutes, authUser };
